import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=7074b4e5&"
import script from "./ToolBar.vue?vue&type=script&lang=ts&"
export * from "./ToolBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports